import React, {useEffect, useState} from 'react';
import axios from 'axios';
import './AccountPanel.css';

const API = `${process.env.REACT_APP_BACKEND_URL || window.location.origin}/api/account`;
const headers = () => ({'X-MeldRadar-Account': '1', 'X-Telegram-Init-Data': window.Telegram?.WebApp?.initData || ''});

export default function AccountPanel() {
  const [status, setStatus] = useState(null);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [challenge, setChallenge] = useState(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [reauth, setReauth] = useState(false);
  const refresh = async () => {
    const response = await axios.get(`${API}/status`, {headers: headers(), withCredentials: true});
    setStatus(response.data);
  };
  useEffect(() => { refresh().catch(() => setMessage('Accountstatus niet beschikbaar. Probeer opnieuw.')); }, []);
  const act = async (action) => {
    setBusy(true); setMessage('');
    try { await action(); } catch(e) {
      const detail = e.response?.data?.detail;
      setMessage(typeof detail === 'string' ? detail : 'Verzoek mislukt. Controleer je verbinding en probeer opnieuw.');
      if(e.response?.status === 401) setReauth(true);
    } finally { setBusy(false); }
  };
  const post = (path, body = {}) => axios.post(`${API}/${path}`, body, {headers: headers(), withCredentials: true});
  return <section className="account-panel" aria-label="Account en abonnement">
    <h4>Account &amp; abonnement</h4>
    <p>Gratis gebruiken kan zonder account. Log in om je abonnement op meerdere apparaten te gebruiken.</p>
    {!status && <button disabled={busy} onClick={() => act(refresh)}>Accountstatus ophalen</button>}
    {status?.authenticated && <>
      <strong>{status.plan === 'pro' ? 'MeldRadar Pro' : 'MeldRadar Gratis'}</strong>
      <p>{status.email_hint}</p>
      {status.expires_at && <p>Toegang tot {new Date(status.expires_at).toLocaleDateString('nl-NL')}</p>}
      <p>Telegram: {status.telegram_linked ? 'gekoppeld' : 'niet gekoppeld'}</p>
      {!!window.Telegram?.WebApp?.initData && !status.telegram_linked && <button disabled={busy} onClick={() => act(async () => {await post('telegram/link'); await refresh(); setMessage('Telegram is gekoppeld aan dit account.');})}>Telegram koppelen</button>}
      {status.telegram_linked && <button disabled={busy} onClick={() => act(async () => {await post('telegram/unlink'); await refresh(); setMessage('Telegram is ontkoppeld.');})}>Telegram ontkoppelen</button>}
      <button disabled={busy} onClick={() => act(async () => {await post('logout'); setReauth(false); await refresh(); setMessage(status.telegram_current ? 'E-mailsessie gesloten. Je gekoppelde Telegram-account herkent je nog; ontkoppel Telegram om dat uit te zetten.' : 'Je bent uitgelogd.');})}>Uitloggen</button>
    </>}
    {status && (!status.authenticated || reauth) && (status.login_available ? <form onSubmit={e => {e.preventDefault(); act(async () => {
      if(challenge) {await post('verify', {challenge, code}); setCode(''); setChallenge(null); setReauth(false); await refresh();}
      else {const response = await post('code', {email}); setChallenge(response.data.challenge); setMessage(response.data.message);}
    });}}>
      {reauth && <p>Bevestig je e-mailadres om de koppeling te wijzigen.</p>}
      {!challenge ? <label>E-mailadres<input type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} disabled={busy}/></label>
        : <label>Inlogcode<input inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}" maxLength={6} required value={code} onChange={e => setCode(e.target.value)} disabled={busy}/></label>}
      <button type="submit" disabled={busy}>{busy ? 'Even wachten…' : challenge ? 'Inloggen' : 'Stuur inlogcode'}</button>
      {challenge && <button type="button" disabled={busy} onClick={() => {setChallenge(null); setCode('');}}>Ander adres of nieuwe code</button>}
    </form> : <p>Inloggen wordt binnenkort beschikbaar.</p>)}
    <p>Pro kopen en aankopen herstellen zijn nog niet beschikbaar. Er worden geen kosten in rekening gebracht.</p>
    {message && <p role="status">{message}</p>}
  </section>;
}
